import * as React from "react";
import { ICustomBaseMap } from "./BasemapWidget";
import { useRef } from "react";
import { useMapContext } from "../../Contexts/MapContext";
import { useBaseMapContext } from "../../Contexts/BaseMapContext";
import { BaseMapsMode } from "../enums";
import "./BaseMapItem.scss";

export interface ISubBaseMapItemProps {
    basemap: ICustomBaseMap;
    classNameDefault: string;
    classNameSelected: string;
}

export const SubBaseMapItem = (props: ISubBaseMapItemProps): JSX.Element => {
    const { configA } = useMapContext();
    const { primaryMapId, setSubBasemapConfig, setClickedBasemap, widgetMode, onOverlayMapSelected } =
        useBaseMapContext();

    const basemapRef = useRef<HTMLDivElement>();

    const basemapClass = props.basemap.id === primaryMapId ? props.classNameSelected : props.classNameDefault;

    const buttonClass =
        props.basemap.childMaps && props.basemap.childMaps.length > 0 && configA.basemaps
            ? "arrow esri-icon-up"
            : "hidden-element";

    const onClick = () =>
        widgetMode === BaseMapsMode.default
            ? setClickedBasemap(props.basemap)
            : props.basemap.id !== primaryMapId && onOverlayMapSelected(props.basemap.id);

    return (
        <>
            <div ref={basemapRef} key={props.basemap.id} id={props.basemap.id} className="basemap-container">
                <div className="basemap-container-header" onClick={() => setSubBasemapConfig(props.basemap)}>
                    <button className={buttonClass}></button>
                </div>
                <img
                    className={basemapClass}
                    key={props.basemap.id}
                    src={props.basemap.img}
                    alt={props.basemap.title}
                    onClick={onClick}
                    title={props.basemap.title}
                />
            </div>
        </>
    );
};
